<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/requisicaoServico', query: $route.query }">
        Suprimentos/Requisição Serviços</router-link
      >
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Inativar</label>
      <label v-else> Ver</label>
    </div>
    <div>
      <label
        ><h2>
          Deseja realmente inativar a requisição {{ requisicaoServico.nome }}?
        </h2></label
      >
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <label>Justifique o motivo da inativação:</label>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-textarea
              outlined
              v-model="justificativa"
              clear-icon="mdi-close-circle"
              label="Justificativa"
              prepend-icon="mdi-comment"
              maxlength="200"
              counter
              :rules="[(v) => !!v || 'A Justificativa é obrigatória']"
              required
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <v-form ref="form2" v-model="valid" lazy-validation>
        <formulario
          ref="formulario"
          :grupos="grupos"
          :unidadesMedida="unidadesMedida"
          :produtos="produtos"
          :conversoes="produto.conversoes"
          :possuiConversao="produto.possuiConversao"
          :isAllowed="readOnly"
        />
      </v-form>

      <v-row align="center-left">
        <v-col cols="6" sm="2">
          <v-text-field
            label="N° Requisição"
            v-model="requisicaoServico.nome"
            :items="unidadesAdm"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-text-field
            label="Unidade Administrativa"
            v-model="requisicaoServico.unidadeAdm"
            :items="unidadesAdm"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-text-field
            label="Local de Entrega"
            v-model="requisicaoServico.local"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-text-field label="Ativa" v-model="ativo" readonly></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-text-field
            label="Prioridade"
            v-model="requisicaoServico.prioridade"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-text-field label="Status" v-model="status" readonly></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Observação"
            v-model="requisicaoServico.observacao"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-text-field
            label="Requisitante"
            v-model="requisicaoServico.requisitante"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>

      <v-card>
        <v-data-table :headers="headers" hide-default-footer :items-per-page="-1" :items="produtos">
        </v-data-table>
      </v-card>

      <v-col cols="12" sm="12" class="text-right">
        <v-btn
          :to="{ path: '/requisicaoServico', query: $route.query }"
          color="error"
          class="mr-4"
        >
          Voltar
        </v-btn>
        <v-btn @click="enviar" color="success" class="mr-4"> Inativar </v-btn>
      </v-col>

      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { inativarRequisicaoAsync, obterRequisicaoPorIdAsync } from "../../../services/requisicaoServicoService";
import { getUserPermission, isLoggedUserAdmin } from "@/services/loginService";
import { mapState, mapActions } from "vuex";

export default {
  name: "inativarRequisicaoServico",
  data: () => ({
    overlay: false,
    valid: true,
    readOnly: false,
    showModal: false,
    descricao: null,
    localSelected: null,
    unidadeAdmSelected: null,
    produtos: [],
    indexEdit: null,
    idOrdemServico: "NA",
    errorMessage: false,
    ativo: null,
    justificativa: null,
    status: null,
    headers: [
      { text: "Item", value: "descricao", sortable: false },
      { text: "Cod. Fabricante", value: "codigo", sortable: false },
      { text: "Und.", value: "unidadeMedida", sortable: false },
      { text: "Quantidade", value: "quantidade", sortable: false },
      { text: "Detalhamento", value: "observacao", sortable: false },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
    ],
  }),
  computed: {
    ...mapState("requisicaoServico", ["requisicaoServico"]),
    ...mapState("local", ["locais"]),
    ...mapState("unidadeAdm", ["unidadesAdm"]),
    ...mapState("produto", ["produto", "produtos"]),
    ...mapState("unidadeMedida", ["unidadesMedida"]),
  },
  methods: {
    ...mapActions("unidadeAdm", ["atualizarUnidadesAdm"]),
    ...mapActions("local", ["atualizarLocais"]),
    ...mapActions("centroCusto", ["atualizarCentrosCusto"]),
    ...mapActions("produto", ["atualizarProdutos", "atualizarProduto"]),
    ...mapActions("requisicaoServico", [
      "atualizarRequisicaoServico",
      "updateRequisicaoServico",
    ]),
    async carregarTela() {
      this.overlay = true;
      try {
        const idRota = Number(this.$route.query.id);
        if (idRota > 0) {
          const resposta = await obterRequisicaoPorIdAsync(idRota);
          if (!resposta || resposta.status !== 200) {
            this.$router.push("/requisicaoServico");
            return;
          }
          this.atualizarRequisicaoServico(resposta.data);
        }

        if (!this.requisicaoServico?.id) {
          this.$router.push("/requisicaoServico");
          return;
        }

        this.inicializarCampos();
      } finally {
        this.overlay = false;
      }
    },
    inicializarCampos() {
      this.readOnly = true;
      this.tipo = this.requisicaoServico.prioridade.toString();
      this.produtos = this.requisicaoServico.produtos || [];
      this.idOrdemServico =
        this.requisicaoServico.idOrdemServico == null ||
        this.requisicaoServico.idOrdemServico == 0
          ? "NA"
          : this.requisicaoServico.idOrdemServico;
      this.unidadeAdmSelected = this.findUnidadeAdm(
        this.requisicaoServico.idUnidadeAdm
      );
      this.localSelected = this.findLocal(this.requisicaoServico.idLocalEntrega);
      this.ativo = this.requisicaoServico.ativo ? "Sim" : "Nao";
      switch (this.requisicaoServico.status) {
        case "AA":
          this.status = "Ag. Aprovacao";
          break;
        case "PA":
          this.status = "Pend. Almoxarifado";
          break;
        case "GS":
          this.status = "Gerada Solicitacao";
          break;
        case "AP":
          this.status = "Atendida Parcial";
          break;
        case "AT":
          this.status = "Atendida Total";
          break;
        case "B":
          this.status = "Baixada";
          break;
        case "D":
          this.status = "Declinada";
          break;
        case "I":
          this.status = "Inativa";
          break;
      }
    },
    podeInativar() {
      return (
        this.requisicaoServico.status === "AA" ||
        (isLoggedUserAdmin() && ["AA", "AG", "AL", "PA", "LA", "D", "LD", "PG", "11", "12"].includes(String(this.requisicaoServico.status)))
      );
    },
    async enviar() {
      if (this.podeInativar()) {
        if (this.$refs.form.validate()) {
          this.overlay = true;
          try {
            const resposta = await inativarRequisicaoAsync(
              this.requisicaoServico.id,
              this.justificativa
            );
            if (!resposta || resposta?.status != 200) {
              this.overlay = false;
              this.$alert(
                resposta.message,
                "Desculpe, falha na operação!",
                "error"
              );
            } else {
              this.updateRequisicaoServico(this.mountObjRequisicao());
              this.$store.dispatch("ui/showSnackbar", {
                text: "Requisição inativada!",
                color: "success",
                timeout: 3000,
              });
              this.$router.push({
                path: "/requisicaoServico",
                query: this.$route.query,
              });
            }
          } finally {
            this.overlay = false;
          }
        }
      } else {
        this.$alert(
          "Desculpe. Essa requisição de serviço não está em um status permitido para inativação!",
          "",
          "error"
        );
        this.$router.push({
          path: "/requisicaoServico",
          query: this.$route.query,
        });
      }
    },
    mountObjRequisicao() {
      var requisicaoServico = JSON.parse(
        JSON.stringify(this.requisicaoServico)
      );
      requisicaoServico.status = "I";
      return requisicaoServico;
    },
    findUnidadeAdm(undAdmId) {
      return this.unidadesAdm.find((uda) => uda.id === undAdmId);
    },
    findLocal(localId) {
      return this.locais.find((l) => l.id === localId);
    },
  },
  mounted() {
    this.readOnly = !getUserPermission(6);
  },
  created: function () {
    this.carregarTela();
  },
};
</script>
